import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import LandingPage from './pages/LandingPage';
import ProyectosPage from './pages/ProyectosPage';
import SolicitarPropuesta from './pages/SolicitarPropuesta';
import ContactoPage from './pages/ContactoPage';
import ServiciosPage from './pages/ServiciosPage';
import TecnologiaPage from './pages/TecnologiaPage'; // <-- NUEVA IMPORTACIÓN
import ScrollToTop from './components/ScrollToTop';
import AvisoLegalPage from './pages/AvisoLegalPage';
import PoliticaPrivacidadPage from './pages/PoliticaPrivacidadPage';
import PoliticaCookiesPage from './pages/PoliticaCookiesPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/proyectos" element={<ProyectosPage />} />
          <Route path="/solicitar-propuesta" element={<SolicitarPropuesta />} />
          <Route path="/servicios" element={<ServiciosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          <Route path="/tecnologia" element={<TecnologiaPage />} /> {/* <-- NUEVA RUTA */}
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
<Route path="/politica-cookies" element={<PoliticaCookiesPage />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;